import "./ClientRegistrationMedicalProviderDetailsComponent.scss";
import * as Yup from "yup";
import {IClientMedicalProviderDetails} from "../../../shared/models/client.model";
import {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../constants";
import FormDebuggerComponent from "../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikInputComponent from "../../../shared/components/form-controls/formik-input/FormikInputComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import FormikPhoneInputComponent from "../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import IconButtonComponent from "../../../shared/components/icon-button/IconButtonComponent";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";
import FormikDatePickerComponent
    from "../../../shared/components/form-controls/formik-date-picker/FormikDatePickerComponent";
import {getClientMedicalHistoryDetails} from "../../../store/actions/client.action";
import {setFormChangesData} from "../../../store/actions/form-state.action";
import moment from "moment";

interface ClientRegistrationMedicalProviderDetailsComponentProps {
    onNext: () => void;
    appointmentId: any
}

const ClientMedicalProviderDetailsFormValidationSchema = Yup.object({
    // medical_provider_info: Yup.object({
    //     name: Yup.string().nullable(),
    //     primary_phone: Yup.string().nullable(),
    //     last_examination_date: Yup.string().nullable(),
    // })
});

const ClientMedicalProviderDetailsFormInitialValues: IClientMedicalProviderDetails = {
    medical_provider_info: {
        family_doctor_name: "",
        referring_doctor_name: "",
        md_phone: "",
        primary_phone: "",
        last_examination_date: "",
        appointment_id: ""
    }
}

const ClientRegistrationMedicalProviderDetailsComponent = (props: ClientRegistrationMedicalProviderDetailsComponentProps) => {

    const {onNext, appointmentId} = props;
    const dispatch = useDispatch();
    const [clientMedicalProviderDetailsFormInitialValues, setClientMedicalProviderDetailsFormInitialValues] = useState<IClientMedicalProviderDetails>(_.cloneDeep(ClientMedicalProviderDetailsFormInitialValues));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoaded,
    } = useSelector((state: IRootReducerState) => state.client);


    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalProviderDetailsFormInitialValues(clientMedicalHistoryDetails);
        }
    }, [clientMedicalHistoryDetails, isClientMedicalHistoryDetailsLoaded]);

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {
            ..._.cloneDeep(values),
            is_medical_provider_details_updated: true,
            // appointment_id: currentUser?.appointment_id,
        };
        payload.appointment_id = appointmentId ? appointmentId : currentUser?.appointment_id;
        payload.last_examination_date = CommonService.convertDateFormat(payload.last_examination_date);
        payload.is_medical_questionnaire_filled = true;
        CommonService._client.ClientMedicalProviderInfoDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                dispatch(getClientMedicalHistoryDetails());
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, [dispatch, currentUser?.appointment_id, onNext, appointmentId]);

    return (
        <div
            className={'client-registration-details-block client-registration-medical-provider-details-component'}>
            <div className="client-registration-details-block__header">
                <div className="client-registration-details-block__title">
                    Medical Provider Information
                </div>
            </div>
            <div className="client-registration-details-block__body">
                <Formik
                    validationSchema={ClientMedicalProviderDetailsFormValidationSchema}
                    initialValues={clientMedicalProviderDetailsFormInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={onSubmit}
                >
                    {({values, setFieldValue, validateForm, isValid, isSubmitting, dirty}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                            if (dirty) {
                                dispatch(setFormChangesData(true));
                            }
                        }, [validateForm, values, dirty]);
                        return (
                            <Form className="t-form" noValidate={true}>
                                <FormDebuggerComponent values={values} showDebugger={false}/>
                                <div className="t-form-controls with-icons">
                                    <div className={"form-header"}>Family Doctor</div>
                                    <div className="ts-row">
                                        <div className="ts-col">
                                            <Field name={'medical_provider_info.family_doctor_name'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            id={"full_name_input"}
                                                            label={'Full Name'}
                                                            placeholder={'Enter Full Name'}
                                                            titleCase={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col">
                                            <Field name={'medical_provider_info.md_phone'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikPhoneInputComponent
                                                            id={"phone_input"}
                                                            label={'MD Phone'}
                                                            placeholder={'MD Phone'}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col-md-1 registration-form-icons-wrapper">
                                            <IconButtonComponent className={"form-helper-icon"}>
                                                <ToolTipComponent
                                                    isFormTooltip={true}
                                                    showArrow={true}
                                                    position={"left"}
                                                    tooltip={<div className={'justified-text'}>This phone number will be
                                                        used to communicate with your family doctor, if required. Please
                                                        ensure that this number is valid and operational.</div>}>
                                                    <ImageConfig.InfoIcon/>
                                                </ToolTipComponent>
                                            </IconButtonComponent>
                                        </div>
                                    </div>
                                    <div className={"form-header"}>Referring Doctor</div>
                                    <div className="ts-row">
                                        <div className="ts-col">
                                            <Field name={'medical_provider_info.referring_doctor_name'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            id={"full_name_input"}
                                                            label={'Full Name'}
                                                            placeholder={'Enter Full Name'}
                                                            titleCase={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col">
                                            <Field name={'medical_provider_info.primary_phone'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikPhoneInputComponent
                                                            id={"phone_input"}
                                                            label={'MD Phone'}
                                                            placeholder={'Enter MD Phone'}
                                                            formikField={field}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col-md-1 registration-form-icons-wrapper">
                                            <IconButtonComponent className={"form-helper-icon"}>
                                                <ToolTipComponent
                                                    isFormTooltip={true}
                                                    showArrow={true}
                                                    position={"left"}
                                                    tooltip={<div className={'justified-text'}>This phone number will be
                                                        used to communicate with your referring doctor regarding your
                                                        case. Please ensure that this number is valid and
                                                        operational.</div>}>
                                                    <ImageConfig.InfoIcon/>
                                                </ToolTipComponent>
                                            </IconButtonComponent>
                                        </div>
                                    </div>
                                    <div className={'form-header'}>Date of Last Physical Examination</div>
                                    <div className="ts-row">
                                        <div className="ts-col">
                                            <Field name={'medical_provider_info.last_examination_date'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikDatePickerComponent
                                                            id={"dob_input"}
                                                            label={''}
                                                            placeholder={'Select Date of Last Examination'}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            // clearable={true}
                                                            maxDate={moment()}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col"></div>
                                        <div className="ts-col-md-1 registration-form-icons-wrapper">

                                        </div>
                                    </div>

                                    <div className="t-form-actions">
                                        <ButtonComponent
                                            id={"next_btn"}
                                            type={"submit"}
                                            size={'large'}
                                            suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                            disabled={!isValid || isSubmitting}
                                            isLoading={isSubmitting}
                                        >
                                            {dirty ? "Next" : "Skip"}
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </Form>
                        )
                            ;
                    }}
                </Formik>
            </div>
        </div>
    )
        ;


};

export default ClientRegistrationMedicalProviderDetailsComponent;
